<template>


</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'shopping-cart',

    data() {
      return {
        canShowCart: true,
      };
    },
    computed: {
      ...mapGetters({getCart: 'getCart'}),

    },

  };
</script>


<style scoped>
    p {
        margin: 0;
    }

    .shopping-cart {
        padding: 10px;
        border-radius: 5px;
        background: #fff url("./../assets/images/green-splash.png") center;
        color: #fff;
    }
</style>
